import { create } from '@bufbuild/protobuf';

import { logger } from '@gem/modules/logger';

import { mapGroupCounterView, mapChatEvent } from 'APP/model/counter/counterModel.b2b.mapper';
import {
  getChatsPageRequest,
  getMultipleChatsEventsRequest,
} from 'APP/wsApi/wsAppApi/requests/chatRequests';
import { GetChatEventsRequestSchema } from 'APP/wsApi/wsAppApi/types/chat/chat_requests_pb';

import { buildModelError } from '../error/errorBuilder';
import {
  IGroupCounterView,
  IGroupEventResponse,
  IGroupEventsRequestBatch,
} from './counterModel.types';

export async function getGroupsCounters(groupIds: string[]): Promise<IGroupCounterView[]> {
  try {
    // TODO: add BFF API call when backend is ready
    return [];
  } catch (error) {
    logger.get('API').error('group.getGroupsCounters', error);
    throw buildModelError(error);
  }
}

export async function getGroupCountersPage(
  counterTs: number | null,
  limit = 20
): Promise<{ items: IGroupCounterView[]; endPageTs: number | null }> {
  const data = counterTs !== null ? { counterTs: counterTs.toString(), limit } : { limit };
  try {
    const result = await getChatsPageRequest({
      counterTs: data.counterTs ? BigInt(data.counterTs) : undefined,
      limit: data.limit,
    });

    return {
      items: (result.type.value?.items || []).map((item) => mapGroupCounterView(item)),
      // TODO: switch to endPageTs when it will be implemented in server
      // endPageTs: result.type.value?.endPageTs ? Number(result.type.value.endPageTs) : null,
      endPageTs: null,
    };
  } catch (error) {
    logger.get('API').error('group.getGroupsPage', error);
    throw buildModelError(error);
  }
}

export async function getGroupsEvents(
  data: IGroupEventsRequestBatch[]
): Promise<IGroupEventResponse[]> {
  if (!data.length) {
    return [];
  }

  try {
    const result = await getMultipleChatsEventsRequest({
      chats: data.map((item) =>
        create(GetChatEventsRequestSchema, {
          chatId: BigInt(item.groupId),
          cursorTs: item.eventTs ? BigInt(item.eventTs) : undefined,
        })
      ),
    });

    return (result.type.value?.chats || []).map((chat) => ({
      groupId: String(chat.chatId),
      events: chat.events.map(mapChatEvent).filter((event) => !!event),
    }));
  } catch (error) {
    logger.get('API').error('group.getGroupsEvents', error);
    throw buildModelError(error);
  }
}
